import { call, put, takeLatest, all } from 'redux-saga/effects';
import { showMessage } from 'app/store/actions/fuse';
import * as Actions from '../../actions';
import { updateUserInformation } from '../../../auth/store/actions/user.actions';
import userService from '../../../services/userService';

function* fetchProfile(action) {
	const { userId } = action.payload;
	try {
		let response = yield call(() => userService.fetchUserInfo(userId));
		yield put(Actions.fetchProfileSuccess(response.data));
	} catch (error) {
		yield put(
			showMessage({
				message: 'Unable to retrieve User' + error,
				variant: 'error'
			})
		);
		yield put(Actions.fetchProfileFailure());
	}
}

function* updateProfile(action) {
	const { user } = action.payload;
	try {
		const response = yield call(() => userService.updateUser(user));
		yield put(Actions.updateProfileSuccess(response.data));
		yield put(updateUserInformation(response.data));
		yield put(
			showMessage({
				message: 'Profile updated',
				variant: 'success'
			})
		);
	} catch (error) {
		yield put(
			showMessage({
				message: 'Unable to save User' + error,
				variant: 'error'
			})
		);
		yield put(Actions.updateProfileFailure());
	}
}

function* changeProfilePassword(action) {
	const { user } = action.payload;
	try {
		const response = yield call(() => userService.changeUserPassword(user));
		yield put(Actions.changeProfilePasswordSuccess(response.data));
		yield put(
			showMessage({
				message: 'Password updated',
				variant: 'success'
			})
		);
	} catch (error) {
		yield put(
			showMessage({
				message: 'Unable to change password' + error,
				variant: 'error'
			})
		);

		yield put(Actions.changeProfilePasswordFailure());
	}
}

function* watchProfile() {
	yield all([
		takeLatest(Actions.fetchProfile, fetchProfile),
		takeLatest(Actions.updateProfile, updateProfile),
		takeLatest(Actions.changeProfilePassword, changeProfilePassword)
	]);
}

export default watchProfile;
